<widget-header
  [name]="widgetName"
  [editable]="false">

  <widget-menu slot="menu"
    [resource]="resource" />
</widget-header>

@if ((projects$ | async); as projects) {
  <div class="op-widget-box--body">
    @if (projects.length === 0) {
      <div class="op-header-project-select--no-favorites">
        <svg
          class="op-header-project-select--no-favorites-icon"
          star-icon
          size="medium"
        ></svg>
        <p>
          <strong [textContent]="text.no_favorites"></strong>
          <br/>
          <span class="op-header-project-select--no-favorites-subtext"
          [textContent]="text.no_favorites_subtext"></span>
        </p>
      </div>
    }
    @else {
      <ul class="op-widget-project-favorites--list">
        @for (project of projects; track project) {
          <li>
            <svg
              star-fill-icon
              class="op-primer--star-icon"
              size="small"
            ></svg>
            <a
              class="op-widget-project-favorites--link"
              [href]="projectPath(project)"
              [textContent]="project.name">
            </a>
          </li>
        }
      </ul>
    }
  </div>
}
